module.exports = __webpack_public_path__ + "static/wellgood-5669c1683a168a36f204325f4c7469d9.svg";